import React from 'react';
import { Modal } from 'components';
import { ScheduleMessageModalFooter } from './components/ScheduleMessageModalFooter';
import { getScheduleSuggestions } from './scheduleOptions';

import * as S from './styles';

interface ScheduleMessageModalProps {
  isOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  setIsScheduleModalOpen: (value: boolean) => void;
  message: string;
  onSendMessage: (
    { message, sendAt }: { message: string; sendAt: Date },
    onSuccess?: VoidFunction
  ) => void;
}

export const ScheduleMessageModal: React.FC<ScheduleMessageModalProps> = ({
  isOpen,
  setIsModalOpen,
  setIsScheduleModalOpen,
  message,
  onSendMessage
}) => {

  const scheduleOptions = getScheduleSuggestions();

  const onSchedule = async (date: Date) => {
    onSendMessage({ message, sendAt: date }, () => setIsModalOpen(false));
  };

  const onFooterClick = () => {
    setIsModalOpen(false);
    setIsScheduleModalOpen(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsModalOpen(false)}
      title="Agendar mensagem"
      footer={<ScheduleMessageModalFooter onFooterClick={onFooterClick} />}
    >
      <S.ModalDescription>Horário Padrão de Brasília</S.ModalDescription>
      <S.ScheduleOptionsContainer>
        {scheduleOptions.map((option) => (
          <S.ScheduleOption key={option.value} onClick={() => onSchedule(option.date)}>
           <span>{option.label}</span>
            <span>{option.value}</span>
          </S.ScheduleOption>
        ))}
      </S.ScheduleOptionsContainer>
    </Modal>
  );
};
